import React from 'react';
import { motion } from 'framer-motion';
const menuData = {
  hot: [{
    name: 'Americano',
    m: 2,
    l: 3
  }, {
    name: 'Cappuccino',
    m: 4,
    l: 5
  }, {
    name: 'Latte',
    m: 4,
    l: 5
  }, {
    name: 'Mocha',
    m: 4,
    l: 5
  }, {
    name: 'Colado',
    m: 3,
    l: 4
  }, {
    name: 'Caramel Macchiato',
    m: 4,
    l: 5
  }, {
    name: 'Chai',
    m: 4,
    l: 5
  }, {
    name: 'Matcha',
    m: 4,
    l: 5
  }, {
    name: 'Hot Chocolate',
    m: 4,
    l: 5
  }, {
    name: 'Tea',
    m: 2,
    l: null
  }],
  iced: [{
    name: 'Latte',
    m: 5,
    l: 6
  }, {
    name: 'Mocha',
    m: 5,
    l: 6
  }, {
    name: 'Caramel Macchiato',
    m: 5,
    l: 6
  }, {
    name: 'Americano',
    m: 3,
    l: 4
  }, {
    name: 'Chai',
    m: 5,
    l: 6
  }, {
    name: 'Matcha',
    m: 5,
    l: 6
  }],
  frappes: [{
    name: 'Mocha',
    m: 5,
    l: 6
  }, {
    name: 'Caramelo',
    m: 5,
    l: 6
  }, {
    name: 'Vainilla',
    m: 5,
    l: 6
  }, {
    name: 'Matcha',
    m: 5,
    l: 6
  }, {
    name: 'Chai',
    m: 5,
    l: 6
  }, {
    name: 'Chocolate',
    m: 5,
    l: 6
  }],
  smoothies: [{
    name: 'Frutos Rojos',
    m: 5,
    l: null
  }, {
    name: 'Mango',
    m: 5,
    l: null
  }]
};
const MenuSection = ({
  title,
  items,
  delay
}: {
  title: string;
  items: any[];
  delay: number;
}) => <motion.div initial={{
  opacity: 0,
  y: 20
}} whileInView={{
  opacity: 1,
  y: 0
}} viewport={{
  once: true
}} transition={{
  duration: 0.5,
  delay
}} className="bg-white p-8 rounded-3xl shadow-soft border border-hope-mustard/10" data-id="element-116">
    <h3 className="text-2xl font-serif font-bold text-hope-terracotta mb-6 pb-4 border-b border-hope-mustard/20" data-id="element-117">
      {title}
    </h3>
    <div className="space-y-4" data-id="element-118">
      {/* Header row for sizes if applicable */}
      {items.some(item => item.l !== null) && <div className="flex justify-end gap-6 text-sm font-medium text-hope-brown/50 px-2" data-id="element-119">
          <span className="w-8 text-center" data-id="element-120">M</span>
          <span className="w-8 text-center" data-id="element-121">L</span>
        </div>}

      {items.map((item, idx) => <div key={idx} className="flex justify-between items-center group" data-id="element-122">
          <span className="font-medium text-hope-brown group-hover:text-hope-teal transition-colors" data-id="element-123">
            {item.name}
          </span>
          <div className="flex gap-6" data-id="element-124">
            <span className="w-8 text-center font-medium text-hope-brown/80" data-id="element-125">
              ${item.m}
            </span>
            {item.l !== null ? <span className="w-8 text-center font-medium text-hope-brown/80" data-id="element-126">
                ${item.l}
              </span> : <span className="w-8" data-id="element-127"></span>}
          </div>
        </div>)}
    </div>
  </motion.div>;
export function Menu() {
  return <section id="menu" className="py-24 bg-hope-cream relative overflow-hidden" data-id="element-128">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-hope-mustard/5 rounded-full blur-3xl -translate-x-1/2 -translate-y-1/2" data-id="element-129"></div>
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-hope-teal/5 rounded-full blur-3xl translate-x-1/3 translate-y-1/3" data-id="element-130"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-131">
        <div className="text-center mb-16" data-id="element-132">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-4xl md:text-5xl font-serif font-bold text-hope-brown mb-4" data-id="element-133">
            Drinks Menu
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-hope-brown/60 font-medium tracking-widest uppercase text-sm" data-id="element-134">
            Prices in USD
          </motion.p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-135">
          <MenuSection title="Hot Drinks" items={menuData.hot} delay={0} data-id="element-136" />
          <MenuSection title="Iced Drinks" items={menuData.iced} delay={0.1} data-id="element-137" />
          <MenuSection title="Frappes" items={menuData.frappes} delay={0.2} data-id="element-138" />
          <MenuSection title="Smoothies" items={menuData.smoothies} delay={0.3} data-id="element-139" />
        </div>
      </div>
    </section>;
}